exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login_image_wrapper[data-v-00d7bfb2]{background:url(/images/login_placeholder.jpg) no-repeat;background-size:cover;min-width:33.333%;min-height:500px}#login_image[data-v-00d7bfb2]{opacity:0;transition:opacity 1s}", ""]);

// exports
